import React, { Component } from "react";
import Prospect from "./Prospect";
import SimpleReactValidator from "simple-react-validator";
import Demographics from "./Demographics";
import DataTable from "../../Utils/GenericUI/DataTable";
import { connect } from "react-redux";
import { PROSPECT_TABLE_HEADER as header } from "../../Utils/StaticData/DashboardHeader";
//import Soa from "./Soa";
import Calls from "./Calls";
import {
  PROSPECT_MANAGEMENT_INITIAL_STATE,
  PROSPECT_MANAGEMENT_CALLS_INITIAL_STATE,
} from "../initialState";
import Modal from "./Modal";
import { handleDateChange } from "../../Utils/DateFormatter";
import * as DateUtil from "../../Utils/DatePicker";
import { saveAs } from "file-saver";
import SoaDocument from "./../soapdf/SoaDocument";
import { pdf } from "@react-pdf/renderer";
import {
  setEnrollRedirect,
  clearprospectrowData,
  ProspectManagementSaveSoa,
  ProspectManagementSaveDemographics,
  ProspectManagementSaveProspect,
  searchProspect,
  getAgentList,
  loadCallsData,
  setCallerId,
  getCommentsData,
  ProspectManagementSaveCalls,
  setProspectRowData,
  loadDemographics,
  addNewComment,
  loadSoa,
  yearSelection,
  loadprospectrowData,
  getZipCodes,
  getCityList,
  getAuthrelations,
  setStateParams,
  getPlans,
  setFormData,
  planSelectionContinue,
  getCallsDataOnRowSelect,
  loadCampaignNames,
  clearProspectData,
  clearSoaData,
  SoapdfDownload,
} from "../../Redux/Actions/webAppActions";
import * as URL from "../../Redux/API_URL";
import axios from "../../Utils/http";
import history from "../../Utils/History";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { INITIAL_STATE } from "../initialState";
import { AssignProspect } from "./AssignProspect";
import {
  ILS_CONSTS,
  NEBRASKA_CONSTS,
  VERDA_CONSTS,
} from "../../Utils/StaticData/Constant";
import Appointments from "./Appointments";
import { mandatoryFileds } from "../../Utils/StaticData/MandatoryFields";
// import Document from "./Document";
class Prospectdashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newProspect: false,
      prospectManagement: "prospect",

      ProspecttableData:
        this.props.prospectTable?.length > 0
          ? this.props.prospectTable?.map(
              (row) =>
                row.soa === "YES"
                  ? Object.assign(row, {
                      SOA: React.createElement(
                        "a",
                        {
                          class: "fa fa-file-pdf-o",
                          style: { color: "red" },
                          id: "downloadPdf",
                          onClick: this.pdfIconHandler.bind(this),
                        },
                        ""
                      ),
                    })
                  : row
              //row.SOA=React.createElement("a",{class:"fa fa-file-pdf-o",style:{ color: "red" },id:"downloadPdf",onClick:this.pdfIconHandler.bind(this)},"");
            )
          : this.props.prospectTable,
      //callTableData: [{ContactName:"Robert",LastName:"Smith",Relationship:"Uncle",DateofCall:"08/09/2021",CommentDate:"12/09/2021",UserID:"STLA"}],
      callsTableData: this.props.callsTable,
      callCommentTableData: this.props.commentTableData,
      rowsPerPage: 10,
      rowsPerPageCalls: 10,
      rowsPerPageComment: 10,
      selectedRowIndex: 0,
      selectedRowIndexCalls: 0,
      selectedRowIndexComments: 0,
      RpopUp: false,
      data: { ...PROSPECT_MANAGEMENT_INITIAL_STATE },
      callsdata: { ...PROSPECT_MANAGEMENT_CALLS_INITIAL_STATE },
      addComment: false,
      isRowSelectedInCalls: false,
      isRowSelectedInProspect: false,
      key: 1,
      pdfFlag: false,
      enrollFlag: false,
      snackBarOpen: false,
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
      snackBarMsg: "",
      newCall: false,
      validZip: true,
      prospectSaveFlag: false,
      demographicsSave: false,
      callsSaveFlag: false,
      prospectpreviousSelectedData: {},
      demographicspreviousSelectedData: {},
      soapreviousSelectedData: {},
      callspreviousSelectedData: {},
      prospectSaved: false,
      demographicsSaved: false,
      mandatoryMbi: "",
      doubleClick: 0,
      currentProspectRowData: {},
      filteredCity: [],
      isPage: 0,
      selectAllPage: false,
    };
    this.validator = new SimpleReactValidator();
  }
  async componentDidMount() {
    if (!this?.props?.isSuperUser) {
      this.setState({
        data: {
          ...this.state.data,
          assignedTo: this?.props?.loginagentId
            ? this?.props?.loginagentId?.trim()
            : "",
        },
      });
    }
    await this.props.getAuthrelations(this.props?.customerId);
    let prospectsearch = await this.props.searchProspect({
      firstName: "",
      lastName: "",
      statusType: "",
      assignedTo: this?.props?.isAgentRole
        ? this?.props?.loginagentId?.trim()
        : "",
      leadIdNbr: "",
      planCampaignId: "",
    });
    if (prospectsearch?.status != "OK") {
      let msg5 =
        this.props.lang === "es"
          ? "Error al obtener datos. Inténtelo más tarde."
          : "Error while fetching data.Please Try later.";
      this.setState({
        snackBarOpen: true,
        snackBarMsg: msg5,
        snackBarSeverty: "error",
      });
    }
    if (
      this.props.prospectagentList?.length === 1 ||
      this.props.prospectagentList === undefined
    ) {
      await this.props.getAgentList(this.props?.customerId);
      // if(!this?.props?.isSuperUser){
      //   this.setState({ data: { ...this.state.data, "assignedTo": this?.props?.agentFullName?this?.props?.agentFullName?.trim():"" } });
      // }
    }

    if (
      this.props.campaignNames?.length === 1 ||
      this.props.campaignNames === undefined
    ) {
      await this.props.loadCampaignNames();
    }
  }
  componentDidUpdate(prevState, prevProps) {
    if (prevState.prospectTable != this.props.prospectTable) {
      this.setState({
        ProspecttableData: this.props.prospectTable,
        //newProspect:false,
        //isRowSelectedInProspect:false,
        selectedRowIndex: 0,
        rowsPerPage: 10,
      });
    }
    if (prevState.callsTable != this.props.callsTable) {
      this.setState({ callsTableData: this.props.callsTable });
    }
    if (prevState.commentTableData != this.props.commentTableData) {
      this.setState({ callCommentTableData: this.props.commentTableData });
    }
    if (prevState.leadIdNbr != this.props.leadIdNbr) {
      this.setState({ leadIdNbr: this.props.leadIdNbr });
    }
    // if (prevProps.newProspect != this.state.newProspect) {
    //   this.setState({ data: {} });
    // }
  }

  addProspect = (e) => {
    this.props.clearprospectrowData();
    this.props.setStateParams("search", false);
    this.props.setStateParams("zipCodes", []);
    this.setState({
      ...this.state,
      filteredCity: [],
      prospectSaveFlag: false,
      demographicsSave: false,
      callsSaveFlag: false,
      newProspect: true,
      isRowSelectedInProspect: false,
      prospectManagement: "prospect",
      data: {
        ...this.state.data,
        firstName: "",
        lastName: "",
        middleInitial: "",
        mbi: "",
        planCampaignName: "",
        eligibleForPartA: "",
        eligibleForPartB: "",
        eligibleForPartD: "",
        assignedTo: this?.props?.isSuperUser
          ? ""
          : this?.state?.data?.assignedTo,
        statusType: "",
        leadIdNbr: "",
        dob: "",
        gender: "",
        preferredLang: "",
        permissionToContact: "",
        planType: "",
        primaryAddress1: "",
        primaryAddress2: "",
        city: "",
        state: "",
        zip: "",
        zipPlus4: "",
        county: "",
        contactPreference: [],
        emailAddress: "",
        homePhone: "",
        cellPhone: "",
        bestTimeToCall: [],
        createdTime: "",
        createdBy: "",
        updatedTime: "",
        updatedBy: "",
      },
    });
  };
  prospectData = (event) => {
    event.preventDefault();
    this.setState(() => ({
      prospectManagement: "prospect",
      isRowSelectedInCalls: false,
    }));
  };
  demographicsData = async (event) => {
    //event.preventDefault();
    // !this.state.prospectSaved
    //   ? this.setState({
    //       snackBarOpen: true,
    //       snackBarMsg: "Please fill and save Prospect first",
    //       snackBarSeverty: "error",
    //     })
    //   : this.setState(() => ({
    //       prospectManagement: "demographics",
    //       isRowSelectedInCalls:false
    //     }));

    this.setState(() => ({
      prospectManagement: "demographics",
      isRowSelectedInCalls: false,
    }));
  };
  // soaData =  (event) => {
  //     event.preventDefault();
  //     this.setState(() => ({
  //         prospectManagement:"soa",
  //         RpopUp: true,

  //     }));

  callsData = (event) => {
    //event.preventDefault();
    // !this.state.prospectSaved
    //   ? this.setState({
    //       snackBarOpen: true,
    //       snackBarMsg: "Please fill and save Prospect first",
    //       snackBarSeverty: "error",
    //     })
    //   : this.setState(() => ({
    //       prospectManagement: "calls",
    //     }));
    if (this.props.leadIdNbr) {
      this.setState(() => ({
        prospectManagement: "calls",
      }));
      // if (!this.props.callsTable) {
      this.props.loadCallsData({ leadIdNbr: this.props.leadIdNbr });
      // }
      this.setState({
        callspreviousSelectedData: {
          leadIdNbr: this.props.leadIdNbr,
          customerId: this.props?.customerId,
          contactName: this.props.callsRowData?.contactName,
          lastName: this.props.callsRowData?.lastName,
          relation: this.props.callsRowData?.relation,
          dateOfCall: this.props.callsRowData?.dateOfCall,
          comment:
            this.props.callsRowData?.comment === null
              ? ""
              : this.props.callsRowData?.comment,
        },
      });
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Lead Id number is not available.",
        snackBarSeverty: "error",
      });
    }
  };
  handleChangeRowsPerPage = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPage: rowsPerPage,
    }));
  };
  handleChangeRowsPerPageCalls = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPageCalls: rowsPerPage,
    }));
  };
  handleChangeRowsPerPageCmtTable = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPageComment: rowsPerPage,
    }));
  };
  addCall = async (e) => {
    this.setState(() => ({
      ...this.state,
      newCall: true,

      callsdata: {
        ...this.state.callsdata,
        contactName: "",
        lastName: "",
        relation: "",
        dateOfCall: "",
        comment: "",
      },

      //isRowSelectedInCalls: false,
    }));
    //this.props.setRowSelectedInCalls(this.state.isRowSelectedInCalls);
  };
  prospectrowSelectFirst = async (index, selectedData, rowsPerPage, type) => {
    this.setState(() => ({
      ...this.state,
      // rowsPerPage: rowsPerPage,
      selectedRowIndex: index,
    }));
  };
  //dont remove selectedData parameter
  prospectrowSelect = async (index, selectedData, rowsPerPage, type) => {
    if (type === "ROWSELECT") {
      await this.props.setProspectRowData(selectedData);
      await this.props.loadprospectrowData({
        leadIdNbr: selectedData.leadIdNbr,
      });
    }
    await this.props.setStateParams("search", false);
    this.setState({
      filteredCity: [],
      isRowSelectedInCalls: false,
      newCall: false,
      selectedRowIndexCalls: 0,
      prospectManagement: "prospect",
      prospectSaveFlag: false,
      demographicsSave: false,
      callsSaveFlag: false,
      newProspect: false,
      prospectSaved: type === "ROWSELECT" ? true : false,
      demographicsSaved: type === "ROWSELECT" ? true : false,
      prospectpreviousSelectedData: {
        leadIdNbr: this.props.prospectrowSelectData?.leadIdNbr,
        customerId: this.props?.customerId,
        firstName: this.props.prospectrowSelectData?.firstName,
        middleInitial: this.props.prospectrowSelectData?.middleInitial,
        lastName: this.props.prospectrowSelectData?.lastName,
        mbi: this.props.prospectrowSelectData?.mbi,
        eligibleForPartA: this.props.prospectrowSelectData?.eligibleForPartA,
        eligibleForPartB: this.props.prospectrowSelectData?.eligibleForPartB,
        eligibleForPartD: this.props.prospectrowSelectData?.eligibleForPartD,
        // dob: this.props.prospectrowSelectData?.dob.slice(6, 10) +
        // "-" +this.props.prospectrowSelectData?.dob.slice(0, 2) +
        // "-" +this.props.prospectrowSelectData?.dob.slice(3, 5),
        dob: this.props.prospectrowSelectData?.dob,
        gender: this.props.prospectrowSelectData?.gender,
        preferredLang: this.props.prospectrowSelectData?.preferredLang,
        planCampaignId: this.props.prospectrowSelectData?.planCampaignId,
        permissionToContact:
          this.props.prospectrowSelectData?.permissionToContact,
        planType: this.props.prospectrowSelectData?.planType,
        statusType: this.props.prospectrowSelectData?.statusType,
        assignedTo: this.props.prospectrowSelectData?.assignedTo,
        createdBy: this.props.prospectrowSelectData?.createdBy,
        createdTime: this.props.prospectrowSelectData?.createdTime,
      },
      data: {
        ...this.state.data,
        firstName: this.props.prospectrowSelectData?.firstName ?? "",
        lastName: this.props.prospectrowSelectData?.lastName ?? "",
        middleInitial: this.props.prospectrowSelectData?.middleInitial,
        mbi: this.props.prospectrowSelectData?.mbi,
        planCampaignName:
          this.props.prospectrowSelectData?.planCampaignId?.split(","),
        eligibleForPartA: this.props.prospectrowSelectData?.eligibleForPartA,
        eligibleForPartB: this.props.prospectrowSelectData?.eligibleForPartB,
        eligibleForPartD: this.props.prospectrowSelectData?.eligibleForPartD,
        assignedTo: this.props.prospectrowSelectData?.assignedTo,
        statusType: this.props.prospectrowSelectData?.statusType,
        leadIdNbr: this.props.prospectrowSelectData?.leadIdNbr,
        dob: this.props.prospectrowSelectData?.dob,
        gender: this.props.prospectrowSelectData?.gender,
        preferredLang: this.props.prospectrowSelectData?.preferredLang,
        permissionToContact:
          this.props.prospectrowSelectData?.permissionToContact,
        planType: this.props.prospectrowSelectData?.planType ?? "",
        createdTime: this.props.prospectrowSelectData?.createdTime,
        createdBy: this.props.prospectrowSelectData?.createdBy,
        updatedTime: this.props.prospectrowSelectData?.updatedTime,
        updatedBy: this.props.prospectrowSelectData?.updatedBy,
      },
    });

    if (this.props.leadIdNbr) {
      let payload = {
        leadIdNbr: this.props.leadIdNbr,
      };

      const demoresponse = await this.props.loadDemographics(payload);
      if (demoresponse.status === "OK") {
        //demograghics load data
        if (this.props.demographicsData.zip) {
          await this.props.getZipCodes(this.props.demographicsData.zip);
          await this.props.getCityList({
            zipCd: this.props.demographicsData.zip,
          });
        }
        if (this.props?.demographicsData.county) {
          let countyName = this.props.zipCodes.filter(
            (county) =>
              county?.countyCode === this.props?.demographicsData?.county
          )[0]?.countyName;
          let filteredCity2 = [];
          filteredCity2 = this.props.cityList.filter(
            (city) => city.countyCode.trim() === countyName?.trim()
            //this.props?.demographicsData.county?.trim()
          );
          await this.setState({
            filteredCity: filteredCity2,
          });
        }
        await this.setState({
          demographicspreviousSelectedData: {
            leadIdNbr: this.props.leadIdNbr,
            customerId: this.props?.customerId,
            primaryAddress1:
              this.props.demographicsData.primaryAddress1 === null
                ? ""
                : this.props.demographicsData.primaryAddress1,
            primaryAddress2:
              this.props.demographicsData.primaryAddress2 === null
                ? ""
                : this.props.demographicsData.primaryAddress2,
            city:
              this.props.demographicsData.city === null
                ? ""
                : this.props.demographicsData.city,
            state:
              this.props.demographicsData.state === null
                ? ""
                : this.props.demographicsData.state,
            zip:
              this.props.demographicsData.zip === null
                ? ""
                : this.props.demographicsData.zip,
            zipPlus4:
              this.props.demographicsData.zipPlus4 === null
                ? ""
                : this.props.demographicsData.zipPlus4,
            county:
              this.props.demographicsData.county === null
                ? ""
                : this.props.demographicsData.county,
            contactPreference:
              this.props.demographicsData.contactPreference === null
                ? ""
                : this.props.demographicsData.contactPreference,
            emailAddress:
              this.props.demographicsData.emailAddress === null
                ? ""
                : this.props.demographicsData.emailAddress,
            homePhone:
              this.props.demographicsData.homePhone === null
                ? ""
                : this.props.demographicsData.homePhone,
            cellPhone:
              this.props.demographicsData.cellPhone === null
                ? ""
                : this.props.demographicsData.cellPhone,
            bestTimeToCall:
              this.props.demographicsData.bestTimeToCall === null
                ? ""
                : this.props.demographicsData.bestTimeToCall,
          },
          data: {
            ...this.state.data,
            primaryAddress1:
              this.props.demographicsData.primaryAddress1 === null
                ? ""
                : this.props.demographicsData.primaryAddress1,
            primaryAddress2:
              this.props.demographicsData.primaryAddress2 === null
                ? ""
                : this.props.demographicsData.primaryAddress2,
            city:
              this.props.demographicsData.city === null
                ? ""
                : this.props.demographicsData.city,
            state:
              this.props.demographicsData.state === null
                ? ""
                : this.props.demographicsData.state,
            zip:
              this.props.demographicsData.zip === null
                ? ""
                : this.props.demographicsData.zip,
            zipPlus4:
              this.props.demographicsData.zipPlus4 === null
                ? ""
                : this.props.demographicsData.zipPlus4,
            county:
              this.props.demographicsData.county === null
                ? ""
                : this.props.zipCodes.filter(
                    (cntyName) =>
                      cntyName.countyCode === this.props.demographicsData.county
                  )[0].countyName,
            contactPreference:
              this.props.demographicsData.contactPreference === null
                ? ""
                : this.props.demographicsData.contactPreference,
            emailAddress:
              this.props.demographicsData.emailAddress === null
                ? ""
                : this.props.demographicsData.emailAddress,
            homePhone:
              this.props.demographicsData.homePhone === null
                ? ""
                : this.props.demographicsData.homePhone,
            cellPhone:
              this.props.demographicsData.cellPhone === null
                ? ""
                : this.props.demographicsData.cellPhone,
            bestTimeToCall:
              this.props.demographicsData.bestTimeToCall === null
                ? ""
                : this.props.demographicsData.bestTimeToCall,
          },
        });
      }
    }
    this.setState(() => ({
      ...this.state,
      rowsPerPage: rowsPerPage,
      selectedRowIndex: index,
    }));
    // if (this.state.pdfFlag) {
    //   this.openPDFDoc();
    // }
    this.setState(() => ({
      //prospectManagement:"soa",
      ...this.state,
      // pdfFlag: false,
      isRowSelectedInProspect: true,
      key: this.state.key + 1,
    }));

    //  if (type === "ROWSELECT") {

    //    await this.setState(() => ({
    //      ...this.state,
    //      isRowSelectedInProspect:true,
    //    }));

    //  }
  };
  rowSelectComment = async (index, selectedData, rowsPerPage, type) => {};
  rowSelect = async (index, selectedData, rowsPerPage, type) => {
    await this.props.getCallsDataOnRowSelect({ callId: selectedData.callId });
    //await this.props.getCommentsData({ callId:selectedData.callId});
    this.setState({
      newCall: false,
      callsdata: {
        ...this.state.callsdata,
        contactName: this.props.callsRowData?.contactName,
        lastName: this.props.callsRowData?.lastName,
        relation: this.props.callsRowData?.relation,
        dateOfCall: this.props.callsRowData?.dateOfCall,
        comment:
          this.props.callsRowData?.comment === null
            ? ""
            : this.props.callsRowData?.comment,
      },
    });
    this.setState(() => ({
      rowsPerPage: rowsPerPage,
      selectedRowIndexCalls: index,
    }));
    if (type === "ROWSELECT") {
      await this.props.setCallerId(selectedData.callId);

      await this.props.getCommentsData({ callId: this.props.callerID });
      await this.setState(() => ({
        ...this.state,
        isRowSelectedInCalls: true,
      }));
    }
  };

  // }
  openModal = () => async (e) => {
    e.preventDefault();
    // const collection = document.getElementsByClassName("modal-backdrop show");
    if (this.props.leadIdNbr) {
      let payload = {
        leadIdNbr: this.props.leadIdNbr,
      };
      const demoresponse = await this.props.loadDemographics(payload);
      if (demoresponse?.status === "OK") {
        if (
          demoresponse?.data?.zip === "" ||
          demoresponse?.data?.zip === null ||
          demoresponse?.data?.zip?.length < 5 ||
          demoresponse?.data?.county === null ||
          demoresponse?.data?.county === ""
        ) {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: "Please fill the mandatory fields in demographics.",
            snackBarSeverty: "error",
          });

          return;
        } else {
          await this.props.setStateParams("zipCodes", []);
          await this.props.getZipCodes(demoresponse.data.zip);
          // await this.props.getAuthrelations()
          if (
            this.props.zipCodes.length === 0 ||
            this.props.zipCodes === null
          ) {
            this.setState({
              snackBarOpen: true,
              snackBarMsg: "Valid county or Zip code code is not available.",
              snackBarSeverty: "warning",
            });
            return;
          }

          await this.props.setStateParams("zip", demoresponse.data.zip);
          if (this.props.zipCodes && this.props.zipCodes.length === 1) {
            await this.props.setStateParams(
              "county",
              this.props.zipCodes[0].countyName
            );
          }
          if (this.props.zipCodes && this.props.zipCodes.length > 1) {
            let county = this.props.zipCodes.filter(
              (cnt) => cnt.countyCode === demoresponse.data.county
            )[0];
            if (county != undefined) {
              await this.props.setStateParams("county", county.countyName);
            }
          }
          const params = this.props.zipCodes.filter(
            (zipcode1) => zipcode1.countyCode === demoresponse.data.county
          );
          const soaresponse = await this.props.loadSoa(payload);

          if (params.length > 0) {
            await this.props.getPlans(
              demoresponse.data.zip,
              params[0].countyCode,
              this.props?.customerId,
              params[0].stateCode,
              this.props?.SOAData?.planYear
                ? this.props?.SOAData?.planYear
                : this.props?.year
              //this.props?.year
            );
          } else {
            await this.props.setStateParams("planCardData", []);
          }
          if (this.props.planCardData.length === 0) {
            this.setState({
              snackBarOpen: true,
              snackBarMsg: "No product Name are available in SOA.",
              snackBarSeverty: "warning",
            });

            return;
          } else {
            if (soaresponse.status === "OK") {
              await this.setState({
                soapreviousSelectedData: {
                  leadIdNbr: this.props.leadIdNbr,
                  customerId: this.props?.customerId,
                  beneRepSignature: this.props.SOAData.beneRepSignature,
                  salesChannelOth: this.props?.SOAData?.salesChannelOth,
                  captureBeneRepSign: this.props.SOAData.captureBeneRepSign,
                  beneRepSignDate: this.props.SOAData.beneRepSignDate,
                  relationshipToBene: this.props.SOAData.relationshipToBene,
                  repName: this.props.SOAData.repName,
                  productName: this.props.SOAData.productName,
                  agentName: this.props.SOAData.agentName,
                  agentPhone: this.props.SOAData.agentPhone,
                  agentSign: this.props.SOAData.agentSign,
                  appointmentDateComp: this.props.SOAData.appointmentDateComp,
                  beneName: this.props.SOAData.beneName,
                  benePhone: this.props.SOAData.benePhone,
                  beneAddress: this.props.SOAData.beneAddress,
                  initialMethodOfContact:
                    this.props.SOAData.initialMethodOfContact,
                  isAuthRep:
                    this.props?.SOAData?.repName?.length > 0 &&
                    this.props?.SOAData?.relationshipToBene?.length > 0
                      ? "YES"
                      : "NO",
                },
                data: {
                  ...this.state.data,
                  agentName: this.props.SOAData.agentName,
                  agentPhone: this.props.SOAData.agentPhone,
                  agentSign: this.props.SOAData.agentSign,
                  appointmentDateComp: this.props.SOAData.appointmentDateComp,
                  beneAddress: this.props.SOAData.beneAddress,
                  beneName: this.props.SOAData.beneName,
                  benePhone: this.props.SOAData.benePhone,
                  beneRepSignDate: this.props.SOAData.beneRepSignDate,
                  beneRepSignature: this.props.SOAData.beneRepSignature,
                  initialMethodOfContact:
                    this.props.SOAData.initialMethodOfContact,
                  salesChannelOth: this.props.SOAData?.salesChannelOth,
                  productName: this.props.SOAData.productName,
                  relationshipToBene: this.props.SOAData.relationshipToBene,
                  repName: this.props.SOAData.repName,
                  isAuthRep:
                    this.props?.SOAData?.repName?.length > 0 &&
                    this.props?.SOAData?.relationshipToBene?.length > 0
                      ? "YES"
                      : "NO",
                  beneBirthDate: this.props?.SOAData?.beneBirthDate,
                  agentSignDate: this.props?.SOAData?.agentSignDate,
                  planYear: this.props?.SOAData?.planYear
                    ? this.props?.SOAData?.planYear
                    : new Date().getFullYear().toString(),
                  beneficiaryInitial: this.props.SOAData?.beneficiaryInitial,
                  medicaidId: this.props.SOAData?.medicaidId ?? "",
                },
              });
            }
            this.setState({
              //prospectManagement:"soa",
              RpopUp: true,
              addComment: false,
              isRowSelectedInCalls: false,
            });
          }
        }
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Demographics is empty please fill first",
          snackBarSeverty: "error",
        });

        return;
      }
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Lead Id number is not available.",
        snackBarSeverty: "error",
      });

      return;
    }

    return;
  };
  openModalCall = (e) => {
    e.preventDefault();
    this.setState({
      // prospectManagement:"soa",
      RpopUp: true,
      addComment: true,
      newCall: false,
    });
  };
  printSoa = (event) => {
    event.preventDefault();

    window.print();
  };
  // soaphoneScript=(event)=>{
  //   event.preventDefault();
  // }
  modalClosed = () => {
    this.props.clearSoaData();
    this.setState({
      RpopUp: false,
      data: { ...this.state.data, agentName: "" },
    });
    var inputs = document.getElementsByTagName("input");
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].disabled = false;
    }
  };
  handleOtherDropdown = (name) => async (event) => {
    const value = event.target
      ? event.target.value
      : event.value || event.label;
    if (name === "relation") {
      await this.setState({
        callsdata: { ...this.state.callsdata, [name]: value },
      });
    }
    if (name === "county") {
      await this.setState({ data: { ...this.state.data, [name]: value } });
      // let filtered = this.props.zipCodes.filter(
      //   (data1) => data1.countyName === value
      // );
      // await this.setState({
      //   data: {
      //     ...this.state.data,
      //     state: filtered[0]?.stateCd,
      //     city: filtered[0]?.cityName,
      //   },
      // });

      let filteredCity = [];

      filteredCity = this.props.cityList.filter(
        (city) => city.countyName.trim() === value?.trim()
      );

      await this.setState({
        filteredCity: filteredCity,
      });

      if (filteredCity?.length >= 1) {
        this.setState({
          ...this.state,
          data: {
            ...this.state.data,
            city: filteredCity[0].cityName,
            state: filteredCity[0]?.stateCode,
          },
        });
      }
    } else {
      await this.setState({ data: { ...this.state.data, [name]: value } });
    }
  };
  handleMultipleSelectionDropdown = (name) => async (data) => {
    let multipleValues = [];
    data.forEach((data1) => {
      multipleValues.push(data1.value);
    });
    if (name === "planCampaignName") {
      if (multipleValues?.length > 5) {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Maximum 5 campaigns can be added.",
          snackBarSeverty: "warning",
        });
        return;
      }
      let occurance = {};
      multipleValues.forEach((ele) => {
        if (occurance[ele]) {
          occurance[ele] += 1;
        } else {
          occurance[ele] = 1;
        }
      });
      if (Object.values(occurance).some((e) => e === 2)) {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Campaign is already added.",
          snackBarSeverty: "warning",
        });
        return;
      }
    }
    if (name == "bestTimeToCall") {
      if (
        this.state.data.bestTimeToCall.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        this.state.data.bestTimeToCall.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    if (name == "contactPreference") {
      if (
        this.state.data.contactPreference.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        this.state.data.contactPreference.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    await this.setState({
      data: { ...this.state.data, [name]: multipleValues },
    });
  };
  handleDropdown = (name) => async (event) => {
    // let value = event.target
    //   ? event.target.label
    //   : event.label || event.value;
    let value = event.target ? event.target.value : event.value;
    if (value === "---Select---") {
      value = "";
    }

    if (name === "planYear") {
      await this.props.getPlans(
        this.props.zip,
        this.props.CountyCd,
        this.props?.customerId,
        this.props.stateCd,
        value
      );
    }

    this.setState({ data: { ...this.state.data, [name]: value } });
  };
  OnBlurEmailAddr = (e) => {
    e.preventDefault();
    let isValidEmail = this.validator.check(
      this.state.data.emailAddress,
      "email"
    );
    if (!isValidEmail) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter valid email address.",
        snackBarSeverty: "error",
      });
    }
  };
  handleMutipleCheckbox = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    //  let multi=[]
    //let multiple=[]
    let multiple = this.state?.data?.productName;
    // ? this.state?.data?.productName
    // : [];
    if (multiple.includes(value)) {
      //let index = multiple.indexOf(value);
      //multiple.splice(index, 1);
      multiple = multiple.replace(value, "")?.replace(",,", ",");
      //removing start and end commas 2 if conditions
      if (multiple[0] === ",") {
        multiple = multiple.substring(1, multiple.length);
      }
      if (multiple[multiple.length - 1] === ",") {
        multiple = multiple.substring(0, multiple.length - 1);
      }
    } else {
      if (multiple?.length > 0) {
        multiple = multiple + "," + value;
      } else {
        multiple = value;
      }
    }
    await this.setState({ data: { ...this.state.data, [name]: multiple } });
  };
  handleChange = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    //please dont remove the below condition,else it will affect initial methd of contact radio button and soa pdf
    if (!name.includes("initialMethodOfContact")) {
      value = value.toUpperCase();
    }
    //let value = event.target.value;
    if (name.includes("zipPlus4")) {
      //value = event.target.value?.trim();
      value = event.target.value?.trim().replace(new RegExp(/[^\d]/, "ig"), "");
    }
    if (name.includes("mbi")) {
      let valid = false;
      //let count=value.length-1

      if (value.length > 0) {
        if (value != this.state.mandatoryMbi) {
          let temp = "";
          for (let i = 0; i < value.length; i++) {
            if (i === 1 || i === 4 || i === 7 || i === 8) {
              valid = value.charAt(i).match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );

                if (valid === true) {
                  temp = temp + value[i];
                  //mandatoryMbi:this.state.mandatoryMbi+value[count]
                }
              }
            }
            if (i === 0 || i === 3 || i === 6 || i === 9 || i === 10) {
              valid = !isNaN(value[i]);

              if (valid === true) {
                //mandatoryMbi:this.state.mandatoryMbi+value[count]
                temp = temp + value[i];
              }
            }
            if (i === 2 || i === 5) {
              valid = value[i].match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );
              }
              valid = !isNaN(value[i]) || valid;
              if (valid === true) {
                //mandatoryMbi:this.state.mandatoryMbi+value[count]
                temp = temp + value[i];
              }
            }
            if (valid === false || valid === null) {
              this.setState({
                snackBarOpen: true,
                snackBarMsg: "Please enter mbi in correct format",
                snackBarSeverty: "error",
              });
            }
          }
          this.setState({
            mandatoryMbi: temp,
            //temp:temp+value[count]
          });
        }
      } else {
        this.setState({
          mandatoryMbi: "",
          //temp:temp+value[count]
        });
      }
    }
    if (
      event.target.type === "checkbox" &&
      (name === "captureBeneficiaryCheckBox" ||
        name === "CaptureAgentSignature" ||
        name === "captureBeneRepSign" ||
        name === "isAuthRep")
    ) {
      value = event.target.checked ? "YES" : "NO";
    }
    if (name.toLowerCase().includes("phone")) {
      value = this.formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
    if (name === "zip") {
      if (value?.length === 5) {
        const response = await this.props.getZipCodes(value);

        const cityListResponse = await this.props.getCityList({ zipCd: value });

        let filteredCity = cityListResponse.data.filter(
          (item) =>
            item.countyName.trim() === response.data[0]?.countyName?.trim()
        );

        await this.setState({
          filteredCity: filteredCity,
        });

        if (response.data === null) {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: response.message,
            snackBarSeverty: "error",
            validZip: false,
          });
        } else {
          this.setState({
            validZip: true,
            // getZipresponse:response.data
          });
          await this.props.setStateParams("zipCodes", response.data);
          if (response.data.length === 1) {
            await this.setState({
              data: {
                ...this.state.data,
                county: response?.data[0]?.countyName,
                //new
                state: response?.data[0]?.stateCd,
                city: response?.data[0]?.cityName,
              },
            });
          }
          if (response.data.length > 1 || response.data.length === 0) {
            await this.setState({
              data: { ...this.state.data, county: "", state: "", city: "" },
            });
          }
        }
      }
    }
    await this.setState({ data: { ...this.state.data, [name]: value } });
    if (this.state.data?.relationshipToBene === "SLF") {
      await this.setState({
        data: { ...this.state.data, beneName: this.state.data?.repName },
      });
    }
    if (name === "initialMethodOfContact" && value === "Other") {
      await this.setState({
        data: {
          ...this.state.data,
          initialMethodOfContact: "Other",
          salesChannelOth: "",
        },
      });
    }
  };

  formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  handleChangeCalls = async (event) => {
    let name = event.target.name;
    let value = event.target.value.toUpperCase();

    await this.setState({
      callsdata: { ...this.state.callsdata, [name]: value },
    });
  };
  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    DateUtil.getDatePicker("#" + name).datepicker("hide");
    value = handleDateChange(value);
    this.setState((prevState) => ({
      data: { ...prevState.data, [name]: value },
    }));
    if (value === "") {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter date in the MM/DD/YYYY format",
        snackBarSeverty: "error",
      });
    }
  };
  handleDate1 = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    DateUtil.getDatePicker("#" + name).datepicker("hide");
    value = handleDateChange(value);
    if (value === "") {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter date in the MM/DD/YYYY format",
        snackBarSeverty: "error",
      });
    }
    if (value?.length > 10) {
      this.setState((prevState) => ({
        snackBarOpen: true,
        snackBarMsg: "Please enter date in the MM/DD/YYYY format",
        snackBarSeverty: "error",
        callsdata: { ...prevState.callsdata, [name]: "" },
      }));
      return;
    }
    this.setState((prevState) => ({
      callsdata: { ...prevState.callsdata, [name]: value },
    }));
  };
  handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDates(fieldId, e.target.value);
    });
  };
  setDates = async (fieldId, value) => {
    if (fieldId === "dob" || fieldId === "beneBirthDate") {
      if (new Date(value) > new Date()) {
        this.setState((prevState) => ({
          snackBarOpen: true,
          snackBarMsg: "Birth date cannot be a future date.",
          snackBarSeverty: "error",
          data: { ...prevState.data, [fieldId]: "" },
        }));
        return;
      }
    }

    this.setState((prevState) => ({
      data: { ...prevState.data, [fieldId]: value },
    }));

    if (this.state.prospectManagement === "calls") {
      if (
        fieldId === "appointmentDateComp" ||
        fieldId === "agentSignDate" ||
        fieldId === "beneBirthDate"
      ) {
        this.setState((prevState) => ({
          data: { ...prevState.data, [fieldId]: value },
        }));
      } else {
        this.setState((prevState) => ({
          callsdata: { ...prevState.callsdata, [fieldId]: value },
        }));
      }
    } else {
      this.setState((prevState) => ({
        data: { ...prevState.data, [fieldId]: value },
      }));
    }
    DateUtil.getDatePicker("#" + fieldId).datepicker("refresh");
  };
  saveSoa = async () => {
    if (
      (this.state?.data?.isAuthRep === "YES" &&
      (this.state?.data?.repName?.length < 1 ||
        this.state.data?.relationshipToBene?.length < 1)
        ? true
        : false) ||
      this.state?.data?.CaptureAgentSignature === "" ||
      this.state?.data?.CaptureAgentSignature === "NO" ||
      this.state.data?.captureBeneRepSign === "" ||
      this.state.data?.captureBeneRepSign === "NO" ||
      this.state.data.beneRepSignature === "" ||
      //this.state.data.repName === "" ||
      this.state.data.agentName === "" ||
      this.state.data.agentPhone === "" ||
      (this.props.customerId === ILS_CONSTS.ID
        ? this.state.data.agentPhone?.length < 12
        : this.state.data.agentPhone?.length < 14) ||
      this.state.data.beneName === "" ||
      this.state.data.benePhone === "" ||
      this.state.data.benePhone?.length < 14 ||
      this.state.data.beneAddress === "" ||
      this.state.data.initialMethodOfContact === "" ||
      (this.state.data.initialMethodOfContact === "Other"
        ? this.state.data?.salesChannelOth === ""
          ? true
          : false
        : false) ||
      this.state.data.appointmentDateComp === "" ||
      this.state.data.agentSign === "" ||
      this.state.data.productName === "" ||
      (this.props.customerId === NEBRASKA_CONSTS.ID
        ? [undefined, ""].some((e) => this.state.data["agentSignDate"] === e)
        : false) ||
      (this.props.customerId === ILS_CONSTS.ID
        ? [undefined, ""].some(
            (e1) => e1 === this.state.data["beneficiaryInitial"]
          )
        : false) // this field beneficiaryInitial only mandatoty for ILS and only for ILS
      //||
      // this.state.data.relationshipToBene === ""
    ) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please Enter All The Mandatory Fields",
        snackBarSeverty: "warning",
      });
      return;
    } else {
      let payload = {
        leadIdNbr: this.state.data.leadIdNbr
          ? this.state.data.leadIdNbr
          : this.state.leadIdNbr,
        customerId: this.props?.customerId,
        beneRepSignature: this.state.data.beneRepSignature,
        captureBeneRepSign:
          this.state.data.captureBeneRepSign === "Y" ? "Y" : "N",
        beneRepSignDate:
          this.state.data.beneRepSignDate === ""
            ? (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1) +
              "/" +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              "/" +
              new Date().getFullYear() +
              " "
            : //  +
              // new Date().getHours() +
              // "." +
              // new Date().getMinutes() +
              // " " +
              // (new Date().getHours() > 12 ? "pm" : "am")
              this.state.data.beneRepSignDate.slice(0, 10),
        relationshipToBene: this.state.data?.relationshipToBene,
        repName: this.state.data?.repName,
        productName: this.state.data.productName.toString(),
        agentName: this.state.data.agentName,
        agentPhone: this.state.data.agentPhone,
        agentSign: this.state.data.agentSign,
        appointmentDateComp: this.state.data.appointmentDateComp,
        beneName: this.state.data.beneName,
        benePhone: this.state.data.benePhone,
        beneAddress: this.state.data.beneAddress,
        initialMethodOfContact: this.state.data.initialMethodOfContact,
        salesChannelOth:
          this.state.data.initialMethodOfContact === "Other"
            ? this.state.data.salesChannelOth
            : "",
        beneBirthDate: this.state.data?.beneBirthDate ?? "",
        agentSignDate: this.state.data?.agentSignDate ?? "",
        medicaidId: this.state.data?.medicaidId ?? "",
        beneficiaryInitial: this.state.data?.beneficiaryInitial ?? "",
        planYear: this.state.data?.planYear ?? "",
      };
      if (
        JSON.stringify(this.state.soapreviousSelectedData) !=
        JSON.stringify(payload)
      ) {
        const response = await this.props.ProspectManagementSaveSoa(payload);
        if (response.status === "OK") {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: "SOA saved successfully!",
            snackBarSeverty: "success",
            RpopUp: false,
            soapreviousSelectedData: payload,
          });
          await this.props.searchProspect({
            firstName:
              this.props.searchPanelData?.prospectSearchPayload?.fname ?? "",
            lastName:
              this.props.searchPanelData?.prospectSearchPayload?.lname ?? "",
            statusType:
              this.props.searchPanelData?.prospectSearchPayload
                ?.prospectStatus ?? "",
            assignedTo:
              this.props.searchPanelData?.prospectSearchPayload?.assigned ?? "",
            leadIdNbr:
              this.props.searchPanelData?.prospectSearchPayload?.leadId ?? "",
            planCampaignId:
              this.props.searchPanelData?.prospectSearchPayload?.campaignName ??
              "",
          });

          return;
        } else {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: "Error occured while saving.",
            snackBarSeverty: "error",
          });
          return;
        }
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Soa already saved",
          snackBarSeverty: "error",
          editForm: true,
        });
        return;
      }
    }
  };
  save = async () => {
    if (this.state.prospectManagement === "demographics") {
      if (!this.state.prospectSaved) {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Please fill and save Prospect first",
          snackBarSeverty: "error",
        });
      } else {
        this.setState({
          demographicsSave: true,
        });
        if (
          (this.state.data?.homePhone?.length >= 10 ||
            this.state.data?.homePhone?.length === 0) &&
          (this.state.data?.cellPhone?.length >= 10 ||
            this.state.data?.cellPhone?.length === 0)
        ) {
          if (
            this.validator.check(this.state?.data?.emailAddress, "email") ===
            true
          ) {
            if (this.state.validZip === true) {
              if (
                this.state.data.primaryAddress1 === "" ||
                // this.state.data.primaryAddress2 === "" ||
                this.state.data.city === "" ||
                this.state.data.state === "" ||
                this.state.data.zip?.length < 5 ||
                //this.state.data.homePhone.length < 10 ||
                this.state.data.county === "" ||
                (this.state.data.contactPreference.includes("E")
                  ? this.state.data?.emailAddress?.length > 0
                    ? false
                    : true
                  : false) ||
                (this.state.data.contactPreference.includes("H")
                  ? this.state.data?.homePhone?.length >= 10
                    ? false
                    : true
                  : false) ||
                (this.state.data.contactPreference.includes("C")
                  ? this.state.data?.cellPhone?.length >= 10
                    ? false
                    : true
                  : false)
              ) {
                this.setState({
                  snackBarOpen: true,
                  snackBarMsg: "Please Enter All The Mandatory Fields!",
                  snackBarSeverty: "warning",
                  isRowSelectedInCalls: false,
                });
                return;
              } else {
                if (
                  this.state.data.cellPhone === "" ||
                  this.state.data.cellPhone?.length === 14
                ) {
                  let payload = {
                    leadIdNbr: this.state.data.leadIdNbr
                      ? this.state.data.leadIdNbr
                      : this.state.leadIdNbr,
                    customerId: this.props?.customerId,
                    primaryAddress1: this.state.data.primaryAddress1,
                    primaryAddress2: this.state.data.primaryAddress2,
                    city: this.state.data.city,
                    state: this.state.data.state?.slice(0, 2),
                    zip: this.state.data.zip?.slice(0, 5),
                    zipPlus4: this.state.data.zipPlus4?.slice(0, 4),
                    county: this.props.zipCodes.filter(
                      (countyCd) =>
                        countyCd?.countyName === this.state.data.county
                    )[0].countyCode,
                    contactPreference:
                      this.state.data.contactPreference.toString(),
                    emailAddress: this.state.data.emailAddress,
                    homePhone: this.state.data.homePhone,
                    cellPhone: this.state.data.cellPhone,
                    bestTimeToCall: this.state.data.bestTimeToCall.toString(),
                  };
                  if (
                    JSON.stringify(
                      this.state.demographicspreviousSelectedData
                    ) != JSON.stringify(payload)
                  ) {
                    const response =
                      await this.props.ProspectManagementSaveDemographics(
                        payload
                      );
                    if (response.status === "OK") {
                      this.setState({
                        demographicsSave: false,
                        snackBarOpen: true,
                        snackBarMsg: "Demographics Saved Successfully!",
                        snackBarSeverty: "success",
                        demographicspreviousSelectedData: payload,
                        prospectManagement: "calls",
                        isRowSelectedInCalls: false,
                      });
                      // return;
                      // this.props.setStateParams("zipCodes",[])
                      await this.props.searchProspect({
                        firstName:
                          this.props.searchPanelData?.prospectSearchPayload
                            ?.fname ?? "",
                        lastName:
                          this.props.searchPanelData?.prospectSearchPayload
                            ?.lname ?? "",
                        statusType:
                          this.props.searchPanelData?.prospectSearchPayload
                            ?.prospectStatus ?? "",
                        assignedTo:
                          this.props.searchPanelData?.prospectSearchPayload
                            ?.assigned ?? "",
                        leadIdNbr:
                          this.props.searchPanelData?.prospectSearchPayload
                            ?.leadId ?? "",
                        planCampaignId:
                          this.props.searchPanelData?.prospectSearchPayload
                            ?.campaignName ?? "",
                      });
                      await this.props.loadCallsData({
                        leadIdNbr: response?.data,
                      });
                      return;
                    } else {
                      this.setState({
                        snackBarOpen: true,
                        snackBarMsg: "Demographics is not Saved.",
                        snackBarSeverty: "error",
                        isRowSelectedInCalls: false,
                      });
                      return;
                    }
                  } else {
                    this.setState({
                      // snackBarOpen: true,
                      // snackBarMsg: "demographics already saved",
                      // snackBarSeverty: "error",
                      editForm: true,
                      isRowSelectedInCalls: false,
                      //newly added prospectManagement: "calls",
                    });
                    this.callsData();
                    return;
                  }
                } else {
                  this.setState({
                    snackBarOpen: true,
                    snackBarMsg: "Please Enter 10-digit phone number",
                    snackBarSeverty: "warning",
                    isRowSelectedInCalls: false,
                  });
                }
              }
            } else {
              this.setState({
                snackBarOpen: true,
                snackBarMsg: "Please Enter Valid Zipcode!",
                snackBarSeverty: "warning",
                isRowSelectedInCalls: false,
              });
              return;
            }
          } else {
            this.setState({
              snackBarOpen: true,
              snackBarMsg: "Please Enter Valid Email!",
              snackBarSeverty: "warning",
            });
          }
        } else {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: "Please 10-digit phone number",
            snackBarSeverty: "warning",
          });
        }
      }
    }
    if (this.state.prospectManagement === "prospect") {
      this.setState({
        prospectSaveFlag: true,
      });
      if (
        this.state.data.firstName === "" ||
        this.state.data.lastName === "" ||
        //this.state.mandatoryMbi?.length<11 ||
        this.state.data.dob === "" ||
        this.state.data.dob.length < 10 ||
        this.state.data.gender === "" ||
        this.state.data.preferredLang === "" ||
        // mandatoryFileds[this.props.customerId]?.prospectManagement?.PlanCampaignName
        (this.props?.supportingServices.some((servc) => servc === "ENRLSVC1") &&
          this.state.data.planCampaignName?.length === 0) ||
        this.state.data.permissionToContact === "" ||
        this.state.data.planType?.length < 1 ||
        this.state.data.statusType === "" ||
        this.state.data.assignedTo === ""
      ) {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Please Enter All The Mandatory Fields!",
          snackBarSeverty: "warning",
          isRowSelectedInCalls: false,
        });
        return;
      } else {
        let payload = {
          leadIdNbr: this.state.data.leadIdNbr,
          customerId: this.props?.customerId,
          firstName: this.state.data.firstName,
          middleInitial: this.state.data.middleInitial,
          lastName: this.state.data.lastName,
          mbi: this.state.data.mbi,
          eligibleForPartA: this.state.data.eligibleForPartA,
          eligibleForPartB: this.state.data.eligibleForPartB,
          eligibleForPartD: this.state.data.eligibleForPartD,
          // dob:
          //   this.state.data.dob.slice(6, 10) +
          //   "-" +
          //   this.state.data.dob.slice(0, 2) +
          //   "-" +
          //   this.state.data.dob.slice(3, 5),
          //gender:this.state.data.gender==="Male"?"M":(this.state.data.gender==="Female"?"F":this.state.data.gender),
          dob: this.state?.data?.dob,
          gender: this.state.data.gender,
          preferredLang: this.state.data.preferredLang,
          planCampaignId:
            this.state.data.planCampaignName.toString() === ""
              ? "0"
              : this.state.data.planCampaignName.toString(),
          permissionToContact: this.state.data.permissionToContact,
          planType: this.state.data.planType.toString(),
          statusType: this.state.data.statusType,
          assignedTo: this.state.data.assignedTo,
          createdBy: this.props.prospectrowSelectData?.createdBy
            ? this.props.prospectrowSelectData?.createdBy
            : "",
          createdTime: this.props.prospectrowSelectData?.createdTime
            ? this.props.prospectrowSelectData?.createdTime
            : "",
        };
        if (
          JSON.stringify(this.state.prospectpreviousSelectedData) !=
          JSON.stringify(payload)
        ) {
          let payloadArray = [payload];
          const response1 = await this.props.ProspectManagementSaveProspect(
            payloadArray
          );
          if (response1.status === "OK") {
            this.setState({
              prospectSaveFlag: false,
              prospectSaved: true,
              snackBarOpen: true,
              snackBarMsg: "Prospect Saved Successfully!",
              snackBarSeverty: "success",
              prospectpreviousSelectedData: payload,
              prospectManagement: "demographics",
              isRowSelectedInCalls: false,
            });
            const response = await this.props.searchProspect({
              firstName:
                this.props.searchPanelData?.prospectSearchPayload?.fname ?? "",
              lastName:
                this.props.searchPanelData?.prospectSearchPayload?.lname ?? "",
              statusType:
                this.props.searchPanelData?.prospectSearchPayload
                  ?.prospectStatus ?? "",
              // assignedTo:  (!this?.props?.isSuperUser && this?.props?.customerId==="HCF0450")?this?.props?.loginagentId?.trim():"",
              assignedTo:
                this.props.searchPanelData?.prospectSearchPayload?.assigned ??
                "",
              leadIdNbr:
                this.props.searchPanelData?.prospectSearchPayload?.leadId ?? "",
              planCampaignId:
                this.props.searchPanelData?.prospectSearchPayload
                  ?.campaignName ?? "",
            });
            if (response.status === "OK") {
              // let leadNum=data.filter((d)=> d.leadIdNbr===response1.data);
              this.setState({
                leadIdNbr: response1.data,
              });
              await this.props.setProspectRowData({
                leadIdNbr: response1.data,
              });
              const resp = await this.props.loadprospectrowData({
                leadIdNbr: response1.data,
              });
              if (this.state.newProspect === true) {
                this.setState({
                  ...this.state,
                  data: {
                    ...this.state.data,
                    createdBy: resp.data?.createdBy,
                    createdTime: resp.data?.createdTime,
                  },
                });
              } else {
                this.setState({
                  ...this.state,
                  data: {
                    ...this.state.data,
                    updatedBy: resp.data?.updatedBy,
                    updatedTime: resp.data?.updatedTime,
                  },
                });
              }
            }
          } else {
            this.setState({
              snackBarOpen: true,
              snackBarMsg: "Prospect is not Saved.",
              snackBarSeverty: "error",
              isRowSelectedInCalls: false,
            });
            return;
          }
        } else {
          this.setState({
            // snackBarOpen: true,
            // snackBarMsg: "prospect already saved",
            // snackBarSeverty: "error",
            editForm: true,
            isRowSelectedInCalls: false,
          });
          this.demographicsData();
          return;
        }
      }
    }
    let flag = VERDA_CONSTS.ID !== this.props.customerId;
    if (this.state.prospectManagement === "appointments") {
      setTimeout(function () {
        let submit = document.getElementById("soaOpen");
        submit.click();
      }, 1000);
    }
    if (this.state.prospectManagement === "calls") {
      if (!this.state.prospectSaved) {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Please fill and save Prospect first",
          snackBarSeverty: "error",
        });
      } else {
        this.setState({
          callsSaveFlag: true,
        });
        // if (
        //   (this.state.callsdata.contactName === "" ||
        //   this.state.callsdata.lastName === "" ||
        //   this.state.callsdata.relation === "" ||
        //   this.state.callsdata.comment === "" ) &&
        //   (this.state.newCall===false)
        // ) {
        // this.setState({
        // snackBarOpen: true,
        // snackBarMsg: "Please add call or go to SOA directly!",
        // snackBarSeverty: "warning"
        // });
        //   this.openModal()
        //   //  return;
        // } else
        if (
          (this.state.callsdata.relation === "---Select---" ||
            this.state.callsdata.contactName === "" ||
            this.state.callsdata.lastName === "" ||
            this.state.callsdata.relation === "" ||
            this.state.callsdata.dateOfCall.length < 10 ||
            this.state.callsdata.comment === "") &&
          this.state.newCall === true
        ) {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: "Please fill all mandatory fields",
            snackBarSeverty: "warning",
          });
          return;
        } else {
          let payload = {
            leadIdNbr: this.props.leadIdNbr,
            customerId: this.props?.customerId,
            contactName: this.state.callsdata.contactName,
            lastName: this.state.callsdata.lastName,
            relation: this.state.callsdata.relation,
            dateOfCall: this.state.callsdata.dateOfCall,
            comment: this.state.callsdata.comment,
          };

          if (
            JSON.stringify(this.state.callspreviousSelectedData) !=
              JSON.stringify(payload) &&
            this.state.newCall === true
          ) {
            const response = await this.props.ProspectManagementSaveCalls(
              payload
            );
            if (response.status === "OK") {
              this.setState({
                newCall: false,
                callsSaveFlag: false,
                snackBarOpen: true,
                snackBarMsg: "Calls Saved Successfully!",
                snackBarSeverty: "success",
                callspreviousSelectedData: payload,
              });
              if (flag) {
                this.setState({
                  ...this.state,
                  prospectManagement: "appointments",
                });
                return;
              } else {
                setTimeout(function () {
                  let submit = document.getElementById("soaOpen");
                  submit.click();
                }, 1000);
                this.props.loadCallsData({ leadIdNbr: this.props.leadIdNbr });
                return;
              }
            } else {
              this.setState({
                snackBarOpen: true,
                snackBarMsg: "Calls is not Saved.",
                snackBarSeverty: "error",
              });
              return;
            }
          } else {
            // this.setState({
            //   snackBarOpen: true,
            //   snackBarMsg: "Calls already saved",
            //   snackBarSeverty: "error",
            //   editForm: true,
            // });
            // return;
            if (flag) {
              this.setState({
                ...this.state,
                prospectManagement: "appointments",
              });
              return;
            } else {
              setTimeout(function () {
                let submit = document.getElementById("soaOpen");
                submit.click();
              }, 1000);
            }
          }
        }
      }
    }
  };
  modalSaveClose = () => {
    const collection1 = document.getElementsByClassName("modal-backdrop show");
    while (collection1.length > 0) {
      collection1[0].remove();
    }
    this.props.clearProspectData();
    this.props.clearSoaData();
    this.setState({
      prospectSaved: false,
      demographicsSaved: false,
      data: {
        ...PROSPECT_MANAGEMENT_INITIAL_STATE,
        assignedTo: !this?.props?.isSuperUser
          ? this?.props?.loginagentId?.trim()
          : "",
      },
      callsdata: { ...PROSPECT_MANAGEMENT_CALLS_INITIAL_STATE },
    });
  };
  handleAddCmt = (event) => {
    event.preventDefault();
    this.setState(() => ({
      //prospectManagement:"soa",
      addComment: true,
    }));
  };
  AddCmt = async (e) => {
    e.preventDefault();
    if (
      this.state.data.addNewComment === undefined ||
      this.state.data.addNewComment === ""
    ) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Comment cannot be empty",
        snackBarSeverty: "warning",
      });
      return;
    } else {
      const response = await this.props.addNewComment({
        callId: this.props.callerID,
        comment: this.state.data.addNewComment,
      });
      if (response.status === "OK") {
        this.setState({
          RpopUp: false,
          snackBarOpen: true,
          snackBarMsg: "Comment Added.",
          snackBarSeverty: "success",
        });

        await this.props.getCommentsData({ callId: this.props.callerID });
        await this.setState({
          data: { ...this.state.data, addNewComment: "" },
        });
        this.props.loadCallsData({ leadIdNbr: this.props.leadIdNbr });
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Error occured while adding comment!",
          snackBarSeverty: "error",
        });
        return;
      }
    }
  };
  pdfIconHandler = (e) => {
    e.preventDefault();
    this.setState(() => ({
      //prospectManagement:"soa",
      pdfFlag: true,
    }));
  };
  openPDFDoc = async (nbr) => {
    let payload = {
      leadIdNbr: nbr,
    };
    const soaresponse = await this.props.loadSoa(payload);
    let blob;
    if (
      [VERDA_CONSTS.ID, NEBRASKA_CONSTS.ID, ILS_CONSTS.ID].some(
        (id) => id === this?.props?.customerId
      )
    ) {
      let payload1 = {
        leadIdNbr: soaresponse?.data?.leadIdNbr,
        customerId: this?.props?.customerId,
        beneRepSignature: soaresponse?.data?.beneRepSignature,
        beneRepSignDate: soaresponse?.data?.beneRepSignDate,
        relationshipToBene: soaresponse?.data?.relationshipToBene,
        repName: soaresponse?.data?.repName,
        productName: soaresponse?.data?.productName,
        agentName: soaresponse?.data?.agentName,
        agentPhone: soaresponse?.data?.agentPhone,
        agentSign: soaresponse?.data?.agentSignutre,
        appointmentDateComp: soaresponse?.data?.appointmentDateComp,
        beneName: soaresponse?.data?.beneName,
        benePhone: soaresponse?.data?.benePhone,
        beneAddress: soaresponse?.data?.beneAddress,
        initialMethodOfContact: soaresponse?.data?.initialMethodOfContact,
        captureBeneRepSign: soaresponse?.data?.captureBeneRepSign,
        salesChannelOth: soaresponse?.data?.salesChannelOth,
        lang: this.props.lang,
        planYear: soaresponse?.data?.planYear,
      };
      const response = await this.props.SoapdfDownload(payload1);
      if (response.status === "OK") {
        blob = "data:application/pdf;base64," + response.data;
        saveAs(blob, "Soa.pdf");
      }
      //  return
    } else {
      blob = await pdf(
        <SoaDocument
          title="Prospect Management"
          pdfData={soaresponse?.data}
          dashboard="prospect"
          customerId={this.props?.customerId}
          authorizedrelations={this.props?.authorizedrelations}
        />
      ).toBlob();
      saveAs(blob, "Soa.pdf");
    }
    this.setState({ pdfFlag: false });
  };
  enrollHandler = async (e) => {
    this.setState({ enrollFlag: true });
  };
  DoEnroll = async (leadIdNbr) => {
    // if(this?.props?.customerId === VERDA_CONSTS.ID){
    //   if(new Date().getFullYear().toString()>"2024"){
    //     await this.props.yearSelection({ planYear:new Date().getFullYear().toString() });
    //   }
    //   else{
    //     await this.props.yearSelection({ planYear:"2024" });
    //   }
    // }
    // if(this.props.customerId!==VERDA_CONSTS.ID){
    //   await this.props.yearSelection({ planYear: "2023" });
    // }
    await this.props.yearSelection({
      planYear: new Date().getFullYear().toString(),
    });

    if (leadIdNbr) {
      let payload = {
        leadIdNbr: leadIdNbr,
      };
      let prospectres = await this.props.loadprospectrowData(payload);
      if (
        prospectres?.data?.enrlAppNumber
        // != "" &&
        // prospectres?.data?.enrlAppNumber != undefined
      ) {
        await this.props.setStateParams(
          "appNum",
          prospectres?.data?.enrlAppNumber
        );
        await this.props.setStateParams("pendingApplFlag", true);
        let loadres = await this.props.setEnrollRedirect(
          prospectres?.data?.enrlAppNumber,
          this.props.agentEmailId,
          this.props?.customerId
        );
        await this.props.setStateParams("loadApi", true);
        await this.props.setStateParams("soa", loadres.data?.soaDetails);
        //nfgf
        let zipArray1 = await this.props.getZipCodes(
          loadres.data.permanentAddress.zipCode
        );
        await this.props.setStateParams(
          "zip",
          loadres.data.permanentAddress.zipCode
        );
        await this.props.setStateParams("ZipCodes", zipArray1.data);
        if (zipArray1.data && zipArray1.data.length === 1) {
          await this.props.setStateParams(
            "county",
            zipArray1.data[0].countyName
          );
        }
        if (zipArray1.data && zipArray1.data.length > 1) {
          let county1 = zipArray1.data.filter(
            (cnt1) => cnt1.countyCode === loadres.data.permanentAddress.countyCd
          )[0];

          await this.props.setStateParams("county", county1.countyName);
        }
        const params1 = zipArray1.data.filter(
          (zipcde1) =>
            zipcde1.countyCode === loadres.data.permanentAddress.countyCd
        );
        if (params1.length > 0) {
          await this.props.getPlans(
            loadres.data.permanentAddress.zipCode,
            params1[0].countyCode,
            this.props?.customerId,
            params1[0].stateCode,
            this?.props?.year
          );
        }
        //fgfh
      } else {
        const demoresponse = await this.props.loadDemographics(payload);
        await this.props.setStateParams("loadApi", false);
        this.props.setStateParams("preEnrollInfo", {});
        await this.props.setStateParams("pendingApplFlag", false);
        if (demoresponse.status === "OK") {
          if (
            demoresponse.data.zip === "" ||
            demoresponse.data.zip?.length < 5 ||
            demoresponse.data.zip === null
          ) {
            this.setState({
              snackBarOpen: true,
              snackBarMsg: "Please fill the mandatory fields in demographics.",
              snackBarSeverty: "error",
              enrollFlag: false,
            });

            return;
          } else {
            let zipArray = await this.props.getZipCodes(demoresponse.data.zip);
            await this.props.setStateParams("zip", demoresponse.data.zip);
            await this.props.setStateParams("ZipCodes", zipArray.data);
            if (zipArray.data && zipArray.data.length === 1) {
              await this.props.setStateParams(
                "county",
                zipArray.data[0].countyName
              );
            }
            if (zipArray.data && zipArray.data.length > 1) {
              let county = zipArray.data.filter(
                (cnt) => cnt.countyCode === demoresponse.data.county
              )[0];

              await this.props.setStateParams("county", county.countyName);
            }
            const params = zipArray.data.filter(
              (zipcode1) => zipcode1.countyCode === demoresponse.data.county
            );
            const soaresponse = await this.props.loadSoa(payload);
            await this.props.setStateParams("year", soaresponse.data?.planYear);
            window.sessionStorage.setItem("year", soaresponse.data?.planYear);
            if (params.length > 0) {
              await this.props.getPlans(
                demoresponse.data.zip,
                params[0].countyCode,
                this.props?.customerId,
                params[0].stateCode,
                soaresponse.data?.planYear
              );
            }
            if (this.props.planCardData.length === 0) {
              this.setState({
                snackBarOpen: true,
                snackBarMsg: "No product Name are available in SOA.",
                snackBarSeverty: "warning",
                enrollFlag: false,
              });
              return;
            } else {
              if (soaresponse.status === "OK") {
                let soa = {
                  repName: soaresponse.data?.repName
                    ? soaresponse.data?.repName
                    : "",
                  repRelationShip: soaresponse.data?.relationshipToBene
                    ? soaresponse.data?.relationshipToBene
                    : "",
                  isAuthRep:
                    soaresponse.data?.repName?.length > 0 &&
                    soaresponse.data?.relationshipToBene?.length > 0
                      ? "YES"
                      : "NO",
                  repSignature: soaresponse.data?.beneRepSignature
                    ? soaresponse.data?.beneRepSignature
                    : "",
                  repDate: soaresponse.data?.beneRepSignDate
                    ? soaresponse.data?.beneRepSignDate
                    : "",
                  productName: soaresponse.data?.productName
                    ? soaresponse.data?.productName
                    : "",
                  agentName: soaresponse.data?.agentName
                    ? soaresponse.data?.agentName
                    : "",
                  beneficiaryName: soaresponse.data?.beneName
                    ? soaresponse.data?.beneName
                    : "",
                  agentPhone: soaresponse.data?.agentPhone
                    ? soaresponse.data?.agentPhone
                    : "",
                  beneficiaryPhone: soaresponse.data?.benePhone
                    ? soaresponse.data?.benePhone
                    : "",
                  agentSignutre: soaresponse.data?.agentSign
                    ? soaresponse.data?.agentSign
                    : "",
                  initialMethodOfContact: soaresponse.data
                    ?.initialMethodOfContact
                    ? soaresponse.data?.initialMethodOfContact
                    : "",
                  salesChannelOth: soaresponse.data?.salesChannelOth
                    ? soaresponse.data?.salesChannelOth
                    : "",
                  beneficiaryAddress: soaresponse.data?.beneAddress
                    ? soaresponse.data?.beneAddress
                    : "",
                  dateApntmntCmpltd: soaresponse.data?.appointmentDateComp
                    ? soaresponse.data?.appointmentDateComp
                    : "",
                  medicaidId: soaresponse.data?.medicaidId ?? "",
                  beneficiaryInitial:
                    soaresponse.data?.beneficiaryInitial ?? "",
                  planYear: soaresponse.data?.planYear ?? "",
                };
                await this.props.setStateParams("soa", soa);
              }
            }
          }
          // let combinedObj=Object.assign({},prospectres?.data,demoresponse?.data)
          // await this.props.setStateParams("preEnrollInfo",combinedObj)
        }
      }
      this.props.setStateParams("prospectflag", true);
      this.props.setStateParams("prospectEnroll", true);
      this.props.setStateParams("isUpdated", false);
      await this.props.setStateParams("leadIdNbr", leadIdNbr);
      await this.props.setStateParams(
        "appNum",
        prospectres?.data?.enrlAppNumber ?? ""
      );
      // await this.props.setStateParams("pendingApplFlag", false);
      await this.setState({ enrollFlag: false });
      history.push("/e-Enroll/select-plan");
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Lead Id number is not available.",
        snackBarSeverty: "error",
        enrollFlag: false,
      });
      return;
    }
  };
  handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  getRowSelectDataForPdf = (CurrentRowdata) => {
    this.setState({
      currentProspectRowData: CurrentRowdata,
    });
  };
  handleCheck = async (val) => {
    this.setState({
      ...this.state,
      ProspecttableData: val,
    });
  };
  handleCheckBox = async (name, val, inde) => {
    let value = val === "Y" ? "N" : "Y";

    let data = [...this.props.prospectTable];
    let index = data.findIndex((x) => x.leadIdNbr === name);
    data[index].checked = value;
    this.setState({
      ...this.state,
      ProspecttableData: data,
      caseSelectedIndex: inde,
    });
  };
  SelectAllHandleCheckBox = (
    rowscount,
    selectall,
    val,
    page,
    selectedrow,
    data1
  ) => {
    let caseData = data1;
    const a = page * rowscount + rowscount;
    let b = 0;
    if (a > caseData.length) {
      b = caseData.length;
    } else {
      b = a;
    }
    if (page < 1) {
      // if (val === "N") {
      //   for (let i = 0; i < b; i++) {
      //     let data = [...caseData];
      //     data[i].checked = val;
      //   }
      // } else {
      let data = caseData;
      for (let i = 0; i < b; i++) {
        //let data= [...caseData];
        data[i].checked = val;
      }

      // }
    } else {
      // if (val === "N") {
      //   for (let i = page * rowscount; i < b; i++) {
      //     let data = [...caseData];
      //     data[i].checked = val;
      //   }
      // } else {
      let data = caseData;
      for (let i = page * rowscount; i < b; i++) {
        //let data = [...caseData];

        data[i].checked = val;
      }
      //}
    }
  };
  serchHandler = async (msg) => {
    this.setState({
      ...this.state,
      snackBarOpen: true,
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "success",
      snackBarMsg: msg,
      selectAllPage: true,
    });
  };
  unSelectAllPage = (val) => {
    this.setState({
      ...this.state,
      selectAllPage: val,
    });
  };
  // documentHandler=(e)=>{
  //   e.preventDefault();
  //   this.setState(() => ({
  //     prospectManagement: "document",
  //   }));
  // }
  appointmentHandler = () => {
    if (this.props.leadIdNbr) {
      this.setState(() => ({
        prospectManagement: "appointments",
      }));
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Lead Id number is not available.",
        snackBarSeverty: "error",
      });
    }
  };

  saveData = (data, isPage) => {
    this.setState({ ...this.state, ProspecttableData: data, isPage: isPage });
  };
  render() {
    let list = this.state.ProspecttableData?.filter(
      (x) => x?.checked === "Y" && x.statusType !== "Closed"
    )?.map((y) => y?.leadIdNbr);
    const { vertical, horizontal, snackBarSeverty, snackBarMsg } = this.state;
    let isCheckboxNeeded = this.props.isSuperUser === true ? true : false;
    let isNeeded = () => {
      return this.state.ProspecttableData[0].SOA === undefined ||
        this.state.ProspecttableData[0].Enroll === undefined
        ? true
        : false;
    };
    let finalData =
      this.state.ProspecttableData?.length > 0
        ? isNeeded()
          ? this.state.ProspecttableData.map((row) =>
              row.soa === "YES" && row.statusType != "Closed"
                ? Object.assign(row, {
                    SOA: React.createElement(
                      "a",
                      {
                        class: "fa fa-file-pdf-o prospectsoapdficon",

                        id: "downloadPdf",
                        onClick: this.pdfIconHandler.bind(this),
                      },
                      ""
                    ),
                    Enroll: React.createElement(
                      "button",
                      {
                        class: "btn btn-dashboard-active mb-2",
                        id: "Enroll",
                        onClick: this.enrollHandler.bind(this),
                      },
                      "Enroll"
                    ),
                  })
                : row.soa === "YES"
                ? Object.assign(row, {
                    SOA: React.createElement(
                      "a",
                      {
                        class: "fa fa-file-pdf-o prospectsoapdficon",

                        id: "downloadPdf",
                        onClick: this.pdfIconHandler.bind(this),
                      },
                      ""
                    ),
                  })
                : row
            )
          : this.state.ProspecttableData
        : this.state.ProspecttableData;
    return (
      <div class="container-campaignmain prospecttablealign mt-3 mb-3">
        <Snackbar
          open={this.state.snackBarOpen}
          autoHideDuration={3000}
          onClose={this.handleSnackClose}
          anchorOrigin={{ vertical, horizontal }}
          key={this.state.vertical + this.state.horizontal}
        >
          <Alert onClose={this.handleSnackClose} severity={snackBarSeverty}>
            {snackBarMsg}
          </Alert>
        </Snackbar>

        <div class="justify-content-between d-flex">
          <h1 class="page-heading-dashboard bold">Prospect Management</h1>
          <AssignProspect
            checkedList={list?.length > 0 ? list : []}
            customerId={this.props.customerId}
            ProspecttableData={this.state.ProspecttableData}
            addProspect={this.addProspect}
            isSuperUser={this.props.isSuperUser}
            searchHandler={this.serchHandler}
          />
          {/* <div>
            <button
              data-toggle="modal"
              data-target="#prospectModal"
              class="btn btn-dashboard-active mb-2 ml-2"
              onClick={this.addProspect}
            >
              Add Prospect
            </button>
          </div> */}
        </div>
        <div>
          <DataTable
            modalSelect={this.state.doubleClick === 2 ? "#prospectModal" : ""}
            // padding="4px 10px 4px 4px"
            fontSize="small"
            width="100%"
            padding="4px 20px 4px 4px"
            dashboard="prospectManagement"
            data={finalData}
            header={header}
            exportAsExcel={true}
            rowsPerPage={this.state.rowsPerPage}
            rowsPerPageOptions={[10, 15, 20]}
            index={this.state.selectedRowIndex}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            sortable={true}
            searchable={true}
            clicked={this.prospectrowSelect}
            clickedFirst={this.prospectrowSelectFirst}
            dateColumn="createdTime"
            doubleClick={true}
            // notClickable={true}
            setClick={(x) => this.setState({ doubleClick: x })}
            pdfFlag={this.state.pdfFlag}
            openPDFDoc={(leadIdNbr) => this.openPDFDoc(leadIdNbr)}
            DoEnroll={(leadIdNbr) => this.DoEnroll(leadIdNbr)}
            enrollFlag={this.state.enrollFlag}
            isCheckBoxNeeded={isCheckboxNeeded}
            handleCheckBox={this.handleCheckBox}
            SelectAllHandleCheckBox={this.SelectAllHandleCheckBox}
            saveData={this.saveData}
            handleCheck={this.handleCheck}
            isPage={this.state.isPage}
            selectAllPage={this.state.selectAllPage}
            unSelectAllPage={this.unSelectAllPage}
          />
        </div>

        <div
          data-keyboard="false"
          data-backdrop="static"
          id="prospectModal"
          class="modal fade z-index-1051"
        >
          <div
            class={
              this.state.prospectManagement === "calls"
                ? "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable "
                : "modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable "
            }
          >
            <div class="modal-content">
              <div class="modal-header modal-headerprospect">
                {(this.state.newProspect === true ||
                  this.state.isRowSelectedInProspect === true) &&
                this.props.search === false ? (
                  <div class="tab-wrapper ml-1">
                    <ul class="nav list">
                      <li class="position-relative">
                        <a
                          href="#prospect"
                          data-toggle="tab"
                          class={
                            this.state.prospectManagement === "prospect"
                              ? "nav-link-active prospectfont"
                              : "nav-link-normal prospectfont"
                          }
                          onClick={this.prospectData}
                        >
                          Prospect
                        </a>
                      </li>
                      <li class="position-relative">
                        <a
                          href={
                            this.state.prospectManagement === "demographics"
                              ? "#demographics"
                              : "#/"
                          }
                          data-toggle="tab"
                          class={
                            // this.state.isRowSelectedInProspect === false ||
                            // this.state.newProspect === true
                            //   ? "disable-link"
                            //   :
                            this.state.prospectManagement === "demographics"
                              ? "nav-link-active prospectfont"
                              : "nav-link-normal prospectfont"
                          }
                          onClick={this.demographicsData}
                        >
                          Demographics
                        </a>
                      </li>
                      <li class="position-relative">
                        <a
                          href={
                            this.state.prospectManagement === "calls"
                              ? "#calls"
                              : "#/"
                          }
                          data-toggle="tab"
                          class={
                            // this.state.isRowSelectedInProspect === false ||
                            // this.state.newProspect === true
                            //   ? "disable-link"
                            //   :
                            this.state.prospectManagement === "calls"
                              ? "nav-link-active prospectfont"
                              : "nav-link-normal prospectfont"
                          }
                          onClick={this.callsData}
                        >
                          Calls
                        </a>
                      </li>
                      {VERDA_CONSTS.ID !== this.props.customerId && (
                        <li class="position-relative">
                          <a
                            href={
                              this.state.prospectManagement === "appointments"
                                ? "#appointments"
                                : "#/"
                            }
                            data-toggle="tab"
                            class={
                              this.state.prospectManagement === "appointments"
                                ? "nav-link-active prospectfont"
                                : "nav-link-normal prospectfont"
                            }
                            onClick={() => this.appointmentHandler()}
                          >
                            Appointments
                          </a>
                        </li>
                      )}
                      <li class="position-relative">
                        <a
                          href={
                            this.state.prospectManagement === "soa"
                              ? "#soa"
                              : "#/"
                          }
                          data-toggle="modal"
                          class={
                            // this.state.isRowSelectedInProspect === false ||
                            // this.state.newProspect === true
                            //   ? "disable-link"
                            //   :
                            this.state.prospectManagement === "soa"
                              ? "nav-link-active prospectfont"
                              : "nav-link-normal prospectfont"
                          }
                          id="soaOpen"
                          onClick={this.openModal()}
                        >
                          SOA
                        </a>
                      </li>
                      {/* <li class="position-relative">
                        <a
                          href={
                            this.state.prospectManagement === "document"
                              ? "#document"
                              : "#/"
                          }
                          data-toggle="tab"
                          class={
                            // this.state.isRowSelectedInProspect === false ||
                            // this.state.newProspect === true
                            //   ? "disable-link"
                            //   :
                            this.state.prospectManagement === "document"
                              ? "nav-link-active prospectfont"
                              : "nav-link-normal prospectfont"
                          }
                          onClick={this.documentHandler}
                        >
                          Document
                        </a>
                      </li> */}
                    </ul>
                  </div>
                ) : null}
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  onClick={this.modalSaveClose}
                >
                  &times;
                </button>
              </div>

              {(this.state.newProspect === true ||
                this.state.isRowSelectedInProspect === true) &&
              this.props.search === false ? (
                <div class="modal-body prospect-x-scroll" key={this.state.key}>
                  <div class="row tab-content prospect-tab tab-contentSharp">
                    <div
                      class={
                        this.state.prospectManagement === "prospect"
                          ? "tab-content-login111 tab-pane fade active show"
                          : "tab-content-login111 tab-pane fade"
                      }
                      id="prospect"
                    >
                      <Prospect
                        prospectSaveFlag={this.state.prospectSaveFlag}
                        data={this.state.data}
                        leadIdNbr={this.state.leadIdNbr}
                        handleChange={this.handleChange}
                        handleDropdown={this.handleDropdown}
                        handleOtherDropdown={this.handleOtherDropdown}
                        handleDates={this.handleDates}
                        handleDate={this.handleDate}
                        mandatoryMbi={this.state.mandatoryMbi}
                        isRowSelectedInProspect={
                          this.state.isRowSelectedInProspect
                        }
                        newProspect={this.state.newProspect}
                        handleMultipleSelectionDropdown={
                          this.handleMultipleSelectionDropdown
                        }
                        isSuperUser={this?.props?.isSuperUser}
                      />
                    </div>
                    {this.state.newProspect === true ||
                    this.state.newProspect === false ? (
                      <>
                        <div
                          class={
                            this.state.prospectManagement === "demographics"
                              ? "tab-content-login111 tab-pane fade active show"
                              : "tab-content-login111 tab-pane fade"
                          }
                          id="demographics"
                        >
                          <Demographics
                            validator={this.validator}
                            OnBlurEmailAddr={this.OnBlurEmailAddr}
                            validZip={this.state.validZip}
                            demographicsSave={this.state.demographicsSave}
                            data={this.state.data}
                            handleChange={this.handleChange}
                            handleDate={this.handleDate}
                            handleDates={this.handleDates}
                            filteredCity={this.state.filteredCity}
                            handleOtherDropdown={this.handleOtherDropdown}
                            handleMultipleSelectionDropdown={
                              this.handleMultipleSelectionDropdown
                            }
                          />
                        </div>

                        <div
                          // class={
                          //   this.state.prospectManagement === "soa"
                          //     ? "tab-content-login111 tab-pane fade active show"
                          //     : "tab-content-login111 tab-pane fade"
                          // }
                          id="soa"
                        >
                          {this.state.RpopUp && (
                            <Modal
                              idName={"modalWidth"}
                              // paddingHeading="5px"
                              show={this.state.RpopUp}
                              modalClosed={() => {
                                this.modalClosed();
                              }}
                              printSoa={this.printSoa}
                              // soaphoneScript={this.soaphoneScript}
                              saveSoa={this.saveSoa}
                              AddCmt={this.AddCmt}
                              inputField
                              sendButton
                              cancelButton
                              data={this.state.data}
                              handleChange={this.handleChange}
                              handleMutipleCheckbox={this.handleMutipleCheckbox}
                              handleDate={this.handleDate}
                              handleDates={this.handleDates}
                              addComment={this.state.addComment}
                              customerId={this?.props?.customerId}
                              handleDropdown={this.handleDropdown}
                            ></Modal>
                          )}
                        </div>
                        <div
                          class={
                            this.state.prospectManagement === "calls"
                              ? "tab-content-login111 tab-pane fade active show scroll container"
                              : "tab-content-login111 tab-pane fade scroll container"
                          }
                          id="calls"
                        >
                          <Calls
                            callsSaveFlag={this.state.callsSaveFlag}
                            tableData={this.state.callsTableData}
                            rowsPerPage={this.state.rowsPerPageCalls}
                            rowsPerPage1={this.state.rowsPerPageComment}
                            selectedRowIndex={this.state.selectedRowIndexCalls}
                            selectedRowIndexComments={
                              this.state.selectedRowIndexComments
                            }
                            handleChangeRowsPerPage={
                              this.handleChangeRowsPerPageCalls
                            }
                            handleChangeRowsPerPageCmtTable={
                              this.handleChangeRowsPerPageCmtTable
                            }
                            rowSelect={this.rowSelect}
                            rowSelectCmt={this.rowSelectComment}
                            commenttableData={this.state.callCommentTableData}
                            handleAddCmt={this.handleAddCmt}
                            openModal={this.openModalCall}
                            data={this.state.callsdata}
                            handleChange={this.handleChangeCalls}
                            handleDates={this.handleDates}
                            handleDate={this.handleDate1}
                            isRowSelectedInCalls={
                              this.state.isRowSelectedInCalls
                            }
                            addCall={this.addCall}
                            newCall={this.state.newCall}
                            authorizedrelations={this.props.authorizedrelations}
                            handleOtherDropdown={this.handleOtherDropdown}
                          />
                        </div>
                        {VERDA_CONSTS.ID !== this.props.customerId &&
                          this.state.prospectManagement === "appointments" && (
                            <div
                              class={
                                this.state.prospectManagement === "appointments"
                                  ? "tab-content-login111 tab-pane fade active show scroll container"
                                  : "tab-content-login111 tab-pane fade scroll container"
                              }
                              id="appointments"
                            >
                              <Appointments leadIdNbr={this.state.leadIdNbr} />
                            </div>
                          )}
                        {/* <div
                     class={
                      this.state.prospectManagement === "document"
                        ? "tab-content-login111 tab-pane fade active show scroll container"
                        : "tab-content-login111 tab-pane fade scroll container"
                    }
                    id="document"
                    >
                      <Document/>
                    </div> */}
                      </>
                    ) : (
                      ""
                    )}

                    {/* <div
               class={
                this.state.addComment
                  ? "tab-content-login111 tab-pane fade active show"
                  : "tab-content-login111 tab-pane fade"
              }
              id="cmt"
               >
               <Modal
                  idName={"modalWidth1"}
                 paddingHeading="5px"
                  show={this.state.RpopUp}
                  modalClosed={() => {
                    this.modalClosed();
                  }}
                  saveSoa={this.saveSoa}
                  inputField
                  sendButton
                  cancelButton
                  data={this.state.data}
                  handleChange={this.handleChange}
                  handleDate={this.handleDate}
                  handleDates={this.handleDates}
                  addComment={this.state.addComment}
                ></Modal>
               </div> */}
                  </div>
                </div>
              ) : null}
              {(this.state.newProspect === true ||
                this.state.isRowSelectedInProspect === true) &&
              this.props.search === false ? (
                <div class="modal-footer">
                  {this.state.prospectManagement === "calls" ? (
                    <button
                      class="btn btn-dashboard-active"
                      onClick={this.addCall}
                    >
                      {" "}
                      Add Call
                    </button>
                  ) : null}
                  {this.state.isRowSelectedInCalls &&
                  this.state.prospectManagement === "calls" ? (
                    <a
                      href="#soa"
                      data-toggle="modal"
                      class="btn btn-dashboard-active"
                      onClick={this.openModalCall}
                    >
                      Add New Comment
                    </a>
                  ) : null}
                  {/* </button> */}
                  {/* {this.state.prospectManagement!=="appointments" && <> */}
                  <button
                    id="submit"
                    onClick={this.save}
                    class="btn btn-dashboard-active"
                  >
                    {" "}
                    Save & Next{" "}
                  </button>
                  <button
                    class="btn btn-campaign"
                    data-dismiss="modal"
                    onClick={this.modalSaveClose}
                  >
                    Close
                  </button>
                  {/* </>} */}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    agentFullName: state.login.agentFullName,
    loginagentId: state.login.agentId,
    agentEmailId: state.login.agentEmailId,
    customerId: state.login.customerId,
    lang: state.webApp.language,
    successignUp: state.login.successfulSignUp,
    prospectTable: state.campaignProspect.prospectTableData,
    // prospectagentList: state.campaignProspect.agentList,
    prospectagentList: state.webApp.membershipAgentList,
    callsTable: state.campaignProspect.callsTableData,
    callerID: state.campaignProspect.callerID,
    commentTableData: state.campaignProspect.commentTableData,
    leadIdNbr: state.campaignProspect.leadIdNbr,
    token: state.login.token,
    demographicsData: state.campaignProspect.demographicsData,
    SOAData: state.campaignProspect.SOAData,
    prospectrowSelectData: state.campaignProspect.prospectrowData,
    planCardData: state.webApp.planCardData,
    prospect: state.campaignProspect.prospectStateEntry,
    callsRowData: state.campaignProspect.callsRowData,
    search: state.webApp.search,
    zipCodes: state.webApp.zipCodes,
    campaignNames: state.campaignProspect.campaignNamesList,
    isLoading: state.spinner.isLoading,
    //authorizedrelations:state.webApp.authorizedrelations,
    authorizedrelations: state.campaignProspect.Authrelation,
    isAgentRole: state.webApp.isAgentRole,
    isSuperUser: state.webApp.isSuperUser,
    agentId: state.webApp.agentId,
    cityList: state.login.cityList,
    supportingServices: state.login.supportingServices,
    CountyCd: state.webApp.CountyCd,
    stateCd: state.webApp.stateCd,
    zip: state.webApp.zip,
  };
};
const mapDispatchToProps = {
  setEnrollRedirect,
  clearprospectrowData,
  getCallsDataOnRowSelect,
  loadSoa,
  loadprospectrowData,
  ProspectManagementSaveCalls,
  ProspectManagementSaveSoa,
  ProspectManagementSaveProspect,
  getAgentList,
  searchProspect,
  ProspectManagementSaveDemographics,
  loadCallsData,
  setCallerId,
  getCommentsData,
  addNewComment,
  setProspectRowData,
  loadDemographics,
  yearSelection,
  getZipCodes,
  getCityList,
  getAuthrelations,
  setStateParams,
  getPlans,
  setFormData,
  planSelectionContinue,
  loadCampaignNames,
  clearProspectData,
  clearSoaData,
  SoapdfDownload,
};
export default connect(mapStateToProps, mapDispatchToProps)(Prospectdashboard);
